import React from "react";
import { useFormikContext } from "formik";
import { Box, FormControlLabel, Grid, Switch, Typography } from "@material-ui/core";
import { permissionOptions, hasPermission, setModulePermission } from "../../utils/userPermissions";
export default function ModulePermissions() {
  const { values, setFieldValue } = useFormikContext();
  const admin = values.profile === "admin";
  return <Box mt={2} mb={3}>
    <Typography variant="h6">Acessos liberados pelo administrador</Typography>
    <Typography variant="body2" color="textSecondary">
      As áreas liberadas permitem usar e configurar o módulo dentro desta empresa. Mapa de cobertura libera somente consulta. Somente um administrador pode conceder ou remover esses acessos.
    </Typography>
    {admin && <Typography variant="body2">O perfil Admin tem acesso total, independentemente dos interruptores.</Typography>}
    <Grid container spacing={1}>
      {permissionOptions.map(([key, label]) => <Grid item xs={12} sm={6} key={key}>
        <FormControlLabel label={label} control={<Switch color="primary" disabled={admin} checked={hasPermission(values,key)} onChange={(_, checked) => setFieldValue("permissions",setModulePermission(values.permissions,key,checked))} />} />
      </Grid>)}
    </Grid>
    <Typography variant="caption" color="textSecondary">Criar usuários, conceder permissões, redefinir senhas de outras pessoas e atribuir filas a usuários continuam exclusivos do Admin. Liberações não dão acesso a outras empresas.</Typography>
  </Box>;
}
